/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleADownIcon16Solid = forwardRef('ArrowShapeTriangleADownIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.651 5h6.697a.9.9 0 0 1 .756 1.388l-3.348 5.19a.9.9 0 0 1-1.512 0l-3.349-5.19A.9.9 0 0 1 4.651 5Z" })));
});
